import styled from "@emotion/styled";

// DatePicker
export const StyledDatePickerWrapper = styled.div`
width: 100%;

.react-datepicker-wrapper {
  width: 100%;
}

.react-datepicker {
  width: 100%;
  padding : 16px;
  width: fit-content;
  height: fit-content;
  border: none;
  border-radius: 15px;
  box-shadow: 0px 4px 20px 0px rgba(00, 00, 00, 0.15);
}
    
.react-datepicker__triangle {
  display: none;
}

.react-datepicker__navigation {
  margin-top: 15px;
  box-sizing: border-box;
}

.react-datepicker__month-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.react-datepicker__current-month {
  padding: 6px 0px;
  font-size: 16px;
  font-weight: 700;
}

.react-datepicker__day-names {
    font-size: 15px;
    font-weight: 500;
}

.react-datepicker__day-name {
    width: 35px;
}   

.react-datepicker__day {
  box-sizing: border-box;
  padding: 4px 8px;
  width: 35px;

  color: #474C52;
  font-size: 14px;
  font-weight: 500;
}

.react-datepicker__day--selected {
  background-color: #3885FF;
  color: white;
  border-radius: 50%;
}

.react-datepicker__day--today {
  font-weight: bold;
  border: 1px solid #3885FF;
}

.react-datepicker__day--disabled, .react-datepicker__month-text--disabled, .react-datepicker__quarter-text--disabled, .react-datepicker__year-text--disabled {
  background-color: #F1F2F3;
  border-radius: 6px;
  color: #474C52;
}

.react-datepicker__header {
  padding: 0;
  background-color: #fff;
  color: #fff;
  border-bottom: none;
  border-radius: 0;    
}

.react-datepicker__navigation--next,
.react-datepicker__navigation--previous {
  border-color: #333;
}

.react-datepicker__month {
  background-color: white;
}
`;